import React from 'react';
import { PlanillaPartido } from '../../../system/PlanillaPartido/PlanillaPartido';
import CustomInputIfc from '../../../lib/FormValidator/Form/CustomInputIfc';
import PlanillaDigitalForm from '../PlanillaDigitalForm';
import DialogTemplate from '../../Common/DialogTemplate';
import { Dropdown, IDropdownOption, Icon, Label, Text, TextField } from '@fluentui/react';
import ToggleInput from '../../../lib/FormValidator/Form/ToggleInput';
import TextArea from '../../../lib/FormValidator/Form/TextAreaField';
import { SUSPENDIDO, FINALIZADO } from '../PlanillaDigitalViewController';
import { Usuario } from '../../../system/Usuario/Usuario';
// @ts-ignore
import useNavigatorOnline from 'use-navigator-online';

interface IFinalizarPartidoDialogProps {
  showConfirmacionPlanillaDialog: boolean;
  setShowConfirmacionPlanillaDialog: (state: boolean) => void;
  setTipoFinalizacion: (state: string) => void;
  tipoFinalizacion: string;
  planillaDigitalForm: PlanillaDigitalForm;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  showErrorConfirmacionArbitro: boolean;
  onRefereeReview: boolean;
  user?: Usuario;
  onAcceptFinalizarPartido: (arbitroSelected: number | null, password: string) => void;
}

const FinalizarPartidoDialog = ({
  showConfirmacionPlanillaDialog,
  setShowConfirmacionPlanillaDialog,
  setTipoFinalizacion,
  tipoFinalizacion,
  planillaDigitalForm,
  onBlurCustomInput,
  showErrorConfirmacionArbitro,
  onAcceptFinalizarPartido,

  ...props
}: IFinalizarPartidoDialogProps) => {
  const [arbitroSelected, setArbitroSelected] = React.useState<number | null>(null);
  const [passwordArbitro, setPasswordArbitro] = React.useState<string>('');

  const arbitrosOptions = React.useMemo(() => {
    const ret: IDropdownOption[] = [];
    const planilla = planillaDigitalForm.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    ret.push({
      key: +planilla.getArbitro1().getId()!,
      text: `${planilla.getArbitro1().getApellido()}, ${planilla.getArbitro1().getNombre()}`,
    });
    if (planilla.getArbitro2()) {
      ret.push({
        key: +planilla.getArbitro2()!.getId()!,
        text: `${planilla.getArbitro2()!.getApellido()}, ${planilla.getArbitro2()!.getNombre()}`,
      });
    }
    return ret;
  }, []);

  React.useEffect(() => {
    if (props.onRefereeReview) {
      const planilla = planillaDigitalForm.getPlanillaPartidoInput().getValue() as PlanillaPartido;
      let arbitroId = +planilla.getArbitro1().getId()!;

      if (props.user?.isArbitroUser()) {
        if (planilla.getArbitro2()?.getEmail() === props.user?.getEmail()) {
          arbitroId = +planilla.getArbitro2()!.getId()!;
        }
      }

      setArbitroSelected(arbitroId);
    }
  }, [props.user, props.onRefereeReview, planillaDigitalForm]);
  const { isOnline } = useNavigatorOnline();

  return (
    <DialogTemplate
      showDialog={showConfirmacionPlanillaDialog}
      toggleShowDialog={() => {
        setShowConfirmacionPlanillaDialog(false);
        setTipoFinalizacion('');
      }}
      title={tipoFinalizacion === SUSPENDIDO ? 'Partido suspendido' : 'Partido finalizado'}
      onAccept={() => {
        onAcceptFinalizarPartido(arbitroSelected, passwordArbitro);
      }}
      validateAccept={() =>
        isOnline ? !arbitroSelected || (!props.onRefereeReview && !passwordArbitro) : false
      }
      onCancel={() => {
        setShowConfirmacionPlanillaDialog(false);
        setTipoFinalizacion('');
      }}
      acceptText={tipoFinalizacion === SUSPENDIDO ? 'Suspender' : 'Confirmar'}
      cancelText={''}
      hideCancelButton
      minWidth={800}
    >
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          {!props.onRefereeReview && isOnline && (
            <>
              <div className="ms-Grid-col ms-sm6 ">
                <Dropdown
                  label="Arbitro"
                  selectedKey={arbitroSelected}
                  options={arbitrosOptions}
                  onChange={(e, o) => {
                    setArbitroSelected(+o!.key);
                    console.log(+o!.key);
                  }}
                ></Dropdown>
              </div>

              <div className="ms-Grid-col ms-sm6 ">
                <TextField
                  label="Contraseña del arbitro"
                  type="password"
                  value={passwordArbitro}
                  onChange={(e, nv) => setPasswordArbitro(nv ? nv : '')}
                  canRevealPassword
                  revealPasswordAriaLabel="Show password"
                />
              </div>

              <div className="ms-Grid-col ms-sm12 mt-2 mb-2">
                <hr></hr>
              </div>
            </>
          )}
          <div className="ms-Grid-col ms-sm12">
            <Label>Tiene informe?</Label>
            <ToggleInput
              input={planillaDigitalForm.getInformeInput()}
              onBlur={onBlurCustomInput}
              offText={'No'}
              onText={'Si'}
            ></ToggleInput>
          </div>
          <div className="ms-Grid-col ms-sm12">
            <TextArea
              input={planillaDigitalForm.getObservacionesInput()}
              label="Observaciones del partido"
              onBlur={onBlurCustomInput}
            ></TextArea>
          </div>
          {showErrorConfirmacionArbitro && (
            <div className="ms-Grid-col ms-sm12 mt-2 mb-2">
              <Text variant="mediumPlus" className="error-color">
                <Icon iconName="AlertSolid" className="text-icon error-color"></Icon>Algo salió mal al
                validarte como arbitro
              </Text>
            </div>
          )}
        </div>
      </div>
    </DialogTemplate>
  );
};

export default FinalizarPartidoDialog;
